export default {"src":"/_next/static/media/exterior-home.a6f72831.svg","height":45,"width":59,"blurWidth":0,"blurHeight":0};